
export default {
  stocks: [],
  stock_category: [],
  popularity: []
}
